module.exports = __webpack_public_path__ + "img/authorize.0ee5233a.png";